<template>
  <div class="card-content">
    <div class="mt-s">
      <div class="mb-5 w-full">
        <fieldset>
          <div class="form-group">
            <input
              v-model="searchQuery"
              type="search"
              class="form-control form-search"
              placeholder="Type to find what you are looking for"
              aria-controls="datatables"
              autofocus
            />
          </div>
          <div class="pull-right">
            <button class="ml-6 btn btn-info" @click="toggleTableStatus()">
              {{ tableStatus ? "Collapse All" : "Expand All" }}
            </button>
          </div>
        </fieldset>
      </div>

      <div>
        <el-table
          stripe
          :data="queriedData"
          :default-sort="defaultSort"
          border
          style="width: 100%"
          :expand-row-keys="expends"
          row-key="id"
          @expand-change="expandChange"
        >
          <el-table-column type="expand">
            <template #default="props">
              <div class="flex flex-col expand-children">
                <div class="mb-xs">
                  <b>Lessons</b>
                </div>

                <div v-for="lesson in props.row.lessons" :key="lesson.id">
                  <div class="flex flex-row items-baseline mb-2">
                    <span class="text-xl">
                      {{ lesson.name }}
                    </span>
                    <div @click="previewLesson(lesson)">
                      <Icon
                        type="play"
                        title="Review"
                        class="ml-2 text-info"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="Topic"
            prop="topic"
            min-width="450"
            sortable
            :sort-orders="['ascending', 'descending']"
          >
            <template #default="props">
              <div class="flex">
                <div class="mr-3">
                  {{ props.row.topic }}
                </div>
                <Icon
                  v-for="condition in props.row.conditions"
                  :key="condition"
                  class="mr-2"
                  :type="condition"
                />
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-for="column in tableColumns"
            :key="column.label"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.minWidth"
            :sortable="column.sortable"
          />
        </el-table>
      </div>

      <!-- <div class="flex justify-between items-center">
        <div>
          <p class="category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>
        </div>

        <p-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        />

        <div>
          <el-select
            v-model="pagination.perPage"
            class="select-default"
            placeholder="Per page"
          >
            <el-option
              v-for="item in pagination.perPageOptions"
              :key="item"
              class="select-default"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
//openPreview(lesson)
import Vue from "vue";
import rolesConstants from "@/components/acl/roles";
//import PPagination from "@components/UIComponents/Pagination.vue";
import { Table, TableColumn } from "element-ui";
import tableConfig from "@providers/table";
import Icon from "@components/UIComponents/TopicIcon/Icon";
import mapper from "@components/UIComponents/TopicIcon/mapper.json";
import PreviewComponent from "./PreviewComponent";

Vue.use(Table);
Vue.use(TableColumn);

export default {
  components: {
    //PPagination,
    Icon,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      expends: [],
      tableStatus: false,
      tableColumns: [
        {
          prop: "periodicity",
          label: "Periodicity",
          minWidth: 100,
          sortable: true,
        },
      ],
      ...tableConfig.data,
      ...rolesConstants,
      propsToSearch: ["topic", "conditions"],
      defaultSort: { prop: "topic", order: "ascending" },
      modal: {},
    };
  },
  computed: {
    tableData() {
      return this.parseDataTable(this.data);
    },
    ...tableConfig.computed,
  },
  async mounted() {},
  methods: {
    expandChange(row) {
      const hasRow = this.expends.includes(row.id);

      if (hasRow) {
        this.expends = this.expends.filter((item) => item !== row.id);
        return;
      }

      this.expends.push(row.id);
      return;
    },
    toggleTableStatus() {
      this.tableStatus = !this.tableStatus;
      this.expends = this.tableStatus ? this.tableData.map(({ id }) => id) : [];
    },
    getRowKeys(row) {
      return row.id;
    },
    parseDataTable(program) {
      if (!program.topicList) {
        return [];
      }
      return program.topicList.map((topic) => {
        return {
          id: topic.id,
          conditions: this.getIconConditions(topic),
          topicStatus: this.getStatus(topic.status),
          topic: topic.name,
          periodicity: topic.frequency,
          lessons: topic.lessonList.map((lesson) => {
            return {
              id: lesson.lesson_id,
              name: lesson.name,
            };
          }),
        };
      });
    },
    getIconConditions(topic) {
      const conditions = ["seasonal", "compressed", "expiration", "international_procedures"];
      return conditions.filter((cond) => topic[cond]);
    },
    getStatus(status) {
      if (!status) {
        return;
      }

      const stringfiedStatus = String(status);

      const [iconName] = Object.entries(mapper).find(([, value]) => {
        return value.code === stringfiedStatus;
      });

      const rejectStatus = [];

      if (rejectStatus.includes(iconName)) {
        return;
      }

      return iconName;
    },
    paginationChange() {
      this.toggleRowExpansion();
      return;
    },
    toggleRowExpansion() {
      this.expends = [].concat(this.expends);
      return;
    },
    async previewLesson(lesson) {
      return this.$modal.show(PreviewComponent, { lesson: lesson });
    },
  },
};
</script>

<style lang="scss"></style>
